import React from 'react';
import Modal from 'react-modal';
import GoogleMap from "./GoogleMap";
import PropTypes from "prop-types";
import Portal from "./Portal";
import translate from "../../services/translation";

const modalCustomStyles = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)'
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#EDE9E2',
        borderRadius: '5px',
        border: '0',
        padding: '20px'
    },
};


function ModalApp ({ modalIsOpen, closeModal, accommodations, selectedAccommodation, setSelectedAccommodation }) {

    return (
        <div>
            <Modal isOpen={modalIsOpen}
                   onRequestClose={closeModal}
                   ariaHideApp={false}
                   contentLabel="Accommodation Modal"
                   style={modalCustomStyles} >

                <div className='map__close_modal'>
                    <button onClick={closeModal} className='button_close_modal'>{translate('button_close_modal')}</button>
                </div>

                <GoogleMap
                    accommodations={accommodations}
                    closeModal={closeModal}
                    selectedAccommodation={selectedAccommodation}
                    setSelectedAccommodation={setSelectedAccommodation}
                />
            </Modal>
        </div>
    );
}

Portal.propTypes = {
    modalIsOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    accommodations: PropTypes.array,
    selectedAccommodation: PropTypes.any,
    setSelectedAccommodation: PropTypes.func
};

export default ModalApp;



// WEBPACK FOOTER //
// ./src/components/Map/MapModal.js